import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {NumberIntervalConfig, NumberIntervalConfigJson} from './number-interval-config';
import {PressureIntervalConfig, PressureIntervalConfigJson} from './pressure-interval-config';
import {CurveConfig, CurveConfigJson} from './curve-config';
import {BorderConfig, BorderConfigJson} from './border-config';
import {PressureGraduationsConfig, PressureGraduationsConfigJson} from './pressure-graduations-config';
import {MaxZoomConfig, MaxZoomConfigJson} from './max-zoom-config';
import {ColorConfig, ColorConfigJson} from './color-config';

export type PressureGraphConfigJson = {
  curve: CurveConfigJson;
  timeMinInterval: NumberIntervalConfigJson;
  pressureInterval: PressureIntervalConfigJson;
  maxZoom: MaxZoomConfigJson;
  background: Array<ColorConfigJson>;
  border: BorderConfigJson;
  graduations: PressureGraduationsConfigJson;
};

export class PressureGraphConfig implements JsonConfigInterface<PressureGraphConfigJson> {

  public readonly curve: CurveConfig = new CurveConfig();
  public readonly timeMinInterval: NumberIntervalConfig = new NumberIntervalConfig();
  public readonly pressureInterval: PressureIntervalConfig = new PressureIntervalConfig();
  public readonly maxZoom: MaxZoomConfig = new MaxZoomConfig();
  public readonly border: BorderConfig = new BorderConfig();
  public readonly graduations: PressureGraduationsConfig = new PressureGraduationsConfig();

  private _background: Array<ColorConfig> = [];

  constructor(json?: PressureGraphConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get background(): Array<ColorConfig> {
    return this._background;
  }

  public deserializeJson(json: PressureGraphConfigJson): void {
    this.curve.deserializeJson(json.curve);
    this.timeMinInterval.deserializeJson(json.timeMinInterval);
    this.pressureInterval.deserializeJson(json.pressureInterval);
    this.maxZoom.deserializeJson(json.maxZoom);
    this._background = json.background.map(colorJson => new ColorConfig(colorJson));
    this.border.deserializeJson(json.border);
    this.graduations.deserializeJson(json.graduations);
  }
}
